import React from 'react';
import { useTranslation } from "react-i18next";
import Table from 'react-bootstrap/Table';
import { useStyles } from "../hooks/useStyles";
import { HeadingBuilder } from "./HeadingBuilder";
import { SkuCategoryPicker } from "./SkuCategoryPicker";

const SkuMenuFilters = ({
  handleCategoryChange,
  handleBrandChange,
  handleNameChange,
  initializeFilters
}) => {
  const { t } = useTranslation();

  const { tableShowNarrow, textAlignLeft } = useStyles();

  return (
    <div>
      <HeadingBuilder
        containerType  = 'h6'
        Size           = 'strong'
        headingText    = {t('sku.category.filterBy')}
        // Filter by:
        tippyAlertText = {t('sku.category.filterByTippyContent')}
        tippyText      = {t('sku.category.filterByTippyContent')}
      />
      <Table responsive bordered hover size="sm" style={tableShowNarrow}>
      {/* striped  */}
        <thead >
        </thead>
        <tbody style={textAlignLeft} >
          <tr>
            <td>
      {t('sku.category.label')}&nbsp;
      {/* Category */}
            </td>
            <td>
      <SkuCategoryPicker
        catName      = "filter"
        catId        = "category_skmf"
        catLabel     = {t('sku.category.showAll')}
        handleChange = {handleCategoryChange}
      />
            </td>
          </tr>
          <tr>
            <td>
      {t('global.label.brand')}&nbsp;
      {/* Brand */}
            </td>
            <td>
        <input onChange={handleBrandChange} placeholder={t('sku.category.enterBrand')}/>
        {/* Enter Brand */}
            </td>
          </tr>
          <tr>
            <td>
      {t('sku.label.label')}&nbsp;
      {/* Name/Label */}
            </td>
            <td>
        <input onChange    = {handleNameChange}
               placeholder = {t('sku.category.enterCharacters')}/>
        {/* Enter any characters */}
            </td>
          </tr>
        </tbody>
      </Table>

      <button onClick={initializeFilters}>{t('sku.category.buttonText')}</button>
      {/* Hide &amp; Reset Filters */}
    </div>
  )
}

export default SkuMenuFilters;